const { clone, nth, last, some } = require('lodash');
const CategoriesConstants = require('./categories.constants');

class CategorySelectionList {
    constructor(categories = []) {
        this.value = clone(categories);
    }

    get hasSelectedCategories() {
        return this.value.length > 0;
    }

    get department() {
        return nth(this.value, CategoriesConstants.categoryLevelIndexes.department);
    }

    get category() {
        return nth(this.value, CategoriesConstants.categoryLevelIndexes.category);
    }

    get subcategory() {
        return nth(this.value, CategoriesConstants.categoryLevelIndexes.subcategory);
    }

    get current() {
        return last(this.value);
    }

    popCategory() {
        this.value = clone(this.value);
        this.value.pop();
    }

    pushCategory(category) {
        this.value = clone(this.value);
        this.value.push(category);
    }

    isActive(categoryNodeId) {
        return some(this.value, category => category.NodeId === categoryNodeId);
    }

    clone() {
        return new CategorySelectionList(this.value);
    }
}

module.exports = CategorySelectionList;



// WEBPACK FOOTER //
// ./src/shop/categories/category-selection-list.js